export const Info =  {
  title: "About me",
  content: [
    "Let me introduce myself in a nutshell,",
    "I used to be a filmmaker, now I'm proud to say I am a programmer with a non-stop hunger of knowledge.",
    "Looking for overcome myself every single day.",
    "Interested in jobs which allows me continuing training my skills, as a programmer and English learner.",
    "It would be a pleasant to become part of your team.",
    "Feel free to contact me at:",
    "daniellorenzocabrera@gmail.com",
  ],
};
